const VehicleTrackingPermissions = {
  // WRITE
  WRITE_VEHICLE_TRACKING_CONFIGURATION: 'vehicle_tracking_configuration__write',
};

export default VehicleTrackingPermissions;
